import { style } from "@vanilla-extract/css";

export const container = style({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "flex-start",
  minHeight: "100vh",
  padding: "var(--cp-spacing-large)",
  // Offset for the 57px sticky auth header (see auth/layout.css.ts).
  paddingBlockStart: "calc(57px + var(--cp-spacing-3xlarge))",
  backgroundColor: "var(--cp-color-white)",
});

export const card = style({
  width: "100%",
  maxWidth: "440px",

  "@media": {
    "(max-width: 767px)": {
      maxWidth: "100%",
    },
    "(min-width: 768px) and (max-width: 1023px)": {
      maxWidth: "480px",
    },
    "(min-width: 1024px)": {
      maxWidth: "440px",
    },
  },
});

export const header = style({
  textAlign: "center",
  marginBlockEnd: "var(--cp-spacing-3xlarge)",

  "@media": {
    "(max-width: 767px)": {
      marginBlockEnd: "var(--cp-spacing-3xlarge)",
    },
  },
});

export const illustration = style({
  width: "120px",
  height: "120px",
  flexShrink: 0,
  marginInline: "auto",
  marginBlockEnd: "var(--cp-spacing-3xlarge)",
  vars: {
    "--fill-branded": "var(--cp-action-color-branded-primary-enabled)",
  },
});

export const illustrationImg = style({
  display: "block",
  width: "100%",
  height: "100%",
  maxWidth: "none",
});

export const title = style({
  font: "var(--cp-text-display2xlarge)",
  color: "var(--cp-color-text-primary)",
  marginBlockEnd: "var(--cp-spacing-small)",
  marginBlockStart: "0",

  "@media": {
    "(max-width: 767px)": {
      font: "var(--cp-text-display-xlarge)",
    },
  },
});

export const subtitle = style({
  font: "var(--cp-text-subtitle-large)",
  color: "var(--cp-color-text-primary)",
  marginBlockStart: "0",
  marginBlockEnd: "0",
});

export const alert = style({
  marginBlockEnd: "var(--cp-spacing-large)",
});

export const fullWidth = style({
  width: "100%",
});

export const link = style({
  textDecoration: "none",
});

export const passwordLabelRow = style({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "baseline",
});

export const forgotLink = style({
  font: "var(--cp-text-subtitle-small)",
  color: "var(--cp-action-color-branded-primary-enabled)",
  textDecoration: "none",
  whiteSpace: "nowrap",
  selectors: {
    "&:hover": {
      textDecoration: "underline",
    },
  },
});

export const backToLoginLink = style({
  display: "block",
  width: "100%",
  textDecoration: "none",
  "@media": {
    "(max-width: 767px)": { display: "none" },
  },
});

export const backLink = style({
  display: "inline-flex",
  alignItems: "center",
  gap: "var(--cp-spacing-xsmall)",
  color: "var(--cp-action-color-branded-primary-enabled)",
  textDecoration: "none",
  font: "var(--cp-text-body-medium)",
  marginBlockEnd: "var(--cp-spacing-2xlarge)",
  selectors: {
    "&:hover": {
      color: "var(--cp-action-color-branded-primary-hover)",
    },
  },
  "@media": {
    "(max-width: 767px)": { display: "none" },
  },
});

// Existing-partner two-layer illustration (separate from login single-SVG illustration)
export const epIllustration = style({
  position: "relative",
  width: "120px",
  height: "120px",
  overflow: "hidden",
  flexShrink: 0,
  marginInline: "auto",
  marginBlockEnd: "var(--cp-spacing-3xlarge)",
});

export const epIllustrationLayerNeutral = style({
  position: "absolute",
  inset: "20.36% 2.89% 20.88% 2.5%",
});

export const epIllustrationLayerBranded = style({
  position: "absolute",
  inset: "19.25% 2.5% 19.25% 6.44%",
  vars: {
    "--fill-0": "var(--cp-action-color-branded-primary-enabled)",
  },
});

// Mobile-specific overrides for the container
export const containerMobile = style({
  "@media": {
    "(max-width: 767px)": {
      minHeight: "100dvh",
      paddingInline: "var(--cp-base-spacing-3xlarge)",
      paddingBlockStart: "57px",
      justifyContent: "safe center",
    },
  },
});
